module.exports = __webpack_public_path__ + "static/02-b43a81a0354150883d293c4fc5b85dc5.jpg";